import { SubjectCategoryType } from "../types/subject.type.ts"
import { api } from "./base.api.ts"

export const getSubjects = async (): Promise<SubjectCategoryType> => {
  const res = await api.get("get-classes")
  return res.data.data
}

export const requestAddSubject = async (title: string) => {
  await api.post("teacher-request-add-class-type", { title })
}
